import { Text, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { ManagementFeeStatus } from '../../../../../store/rateManagement/constants';

import { CardTypes } from '.';

export const MasterAccountField: React.FC<Pick<CardTypes.Props, 'loading' | 'sentOrderDetail'>> = ({
  loading,
  sentOrderDetail,
}) => {
  if (loading || sentOrderDetail?.managementFeeStatusNormalized !== ManagementFeeStatus.Sent) {
    return null;
  }
  const masterAccount = `${sentOrderDetail?.managerAccountNormalized}-${sentOrderDetail?.managerAccountDigitNormalized}`;
  return (
    <Stack direction={{ base: 'row', sm: 'column' }} space={Spacing['stack.quarck']}>
      <Text
        fontSize={Typography['fontsize.md']}
        color="neutral.black"
        fontWeight={{
          base: Typography['fontweight.regular'],
          sm: Typography['fontweight.semibold'],
        }}>
        Conta Master
      </Text>
      <Text
        fontSize={Typography['fontsize.md']}
        color="neutral.dark"
        textAlign={{ base: 'right', sm: 'left' }}
        flex={1}>
        {masterAccount}
      </Text>
    </Stack>
  );
};
